import classNames from 'classnames'
import React from 'react'
import { DarkLightTheme } from '@dustin-web/styledust/constants'
import Icon from '../icon'

type Props = {
  onClose: () => void
  className?: string
  small?: boolean
  theme?: DarkLightTheme
}

export const CloseButton = ({ onClose, className = '', small = false, theme }: Props) => {
  return (
    <button
      className={classNames('c-btn--close', className, {
        'c-btn--sm': small,
      })}
      onClick={onClose}
      aria-label="Close">
      <Icon
        name="close-2"
        className={classNames({
          'i-16': !small,
          'i-12': small,
          'u-color-black': theme === 'white',
          'u-color-white': theme === 'black',
        })}
      />
    </button>
  )
}

export default CloseButton
